module.exports = __webpack_public_path__ + "static/media/ic-calendar.6c514b10.png";